module.exports = __webpack_public_path__ + "static/media/new-headset.c9acfce4.svg";